<template>
    <div>
        <v-select
            v-model="selected"
            :items="courses"
            item-text="title"
            item-value="id"
            :label="label"
            required />
    </div>
</template>

<script>
import axios from 'axios';

export default {
    props: [ 'value', 'current' ],
    data() {
        return {
            selected: '',
            courses: [],
            label: 'Carregando'
        }
    },
    created() {
        this.get();
    },
    watch: {
        selected(){
            const course = this.courses.find( el => el.id == this.selected );
            this.$emit('input', '/curso/' + course.id + '/' + encodeURI(course.title.toLowerCase().replace(/\s/g,'_')));
        }
    },
    methods: {
        async get() {
			const result = await axios.get( this.$myServerAddresses.courses + 'courses', {
                headers: {
                    'X-Fluke': this.$cookies.get('token')
                }
            });
            this.courses = result.data;
            this.label = 'Escolha um curso:';

            this.select();
        },
        select() {
            if( this.$props.current && this.$props.current.type == 'course' ) {
                this.selected = parseInt(this.$props.current.data.split('/')[2]);
            }
        }
    }
}
</script>
